'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Event } from '@/app/donation/_components/Event';
import { InviteFooter } from '@/app/donation/invite/_components/InviteFooter';
import { Image, PageNavigation } from '@/components/client';
import { CenteredDetailTemplate } from '@/components/template/CenteredDetailTemplate';
import { INVITE_COMMON_CONFIG } from '../../../constants';
import { INVITER_SECTION_IMAGES } from '../../constants';
import { BottomSection } from './BottomSection';
import { PrizeSection } from './PrizeSection';
import { RecentWinnersSection } from './RecentWinnersSection';
const BANNER_IMAGE_WIDTH = 850;
export const InvitePageTemplate = () => {
  const $ = _c(6);
  const currentEventKey = INVITE_COMMON_CONFIG.event.eventKey;
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const sectionImages = currentEventKey && currentEventKey in INVITER_SECTION_IMAGES ? INVITER_SECTION_IMAGES[currentEventKey as keyof typeof INVITER_SECTION_IMAGES] : Object.values(INVITER_SECTION_IMAGES).at(-1);
    T0 = CenteredDetailTemplate;
    t0 = "relative flex flex-col items-center bg-Gray-white";
    t1 = <Event />;
    t2 = <PageNavigation donationHomeButton={true} hideHomeButton={true} />;
    t3 = sectionImages?.map(_temp);
    $[0] = T0;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    T0 = $[0];
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <T0><div className={t0}>{t1}{t2}{t3}<ErrorBoundary fallback={null}><Suspense><div className="relative flex w-full flex-col gap-90 bg-B-400 px-20 py-80"><section className="flex w-full flex-col items-center gap-36"><RecentWinnersSection /><PrizeSection /></section></div></Suspense></ErrorBoundary><InviteFooter /><BottomSection /></div></T0>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
function _temp(item) {
  return <Image key={item.src} className={cn("w-full", item.className)} src={item.src} alt={"\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uCE5C\uAD6C \uCD08\uB300 \uC774\uBCA4\uD2B8"} width={BANNER_IMAGE_WIDTH} height={500} />;
}